<template>
    <div class="type-list-box">
        <el-scrollbar>
            <div class="inline-type-list">
                <productTypeRecord
                        v-for="(v, i) in list"
                        :obj="v"
                        :selectedCode="selectedCode"
                        :key="v.id"
                        @clickTypeBox="clickTypeCallback"
                />
            </div>

        </el-scrollbar>
    </div>
</template>

<script setup>
    import {inject} from "vue";
    import productTypeRecord from "@/components/shopopee/quotation/productTypeRecord"

    const props = defineProps(["list", "selectedCode"])
    const emits = defineEmits(["clickTypeBox"])

    const i18n = inject("i18n")

    function clickTypeCallback(obj) {
        emits("clickTypeBox", obj)
    }

</script>

<style scoped>
    .type-list-box {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        background: #f2f1f7;
        height: 40px;
    }

    .inline-type-list {
        display: flex;
        align-items: center;
        /*justify-content: center;*/
        height: 40px;
    }
</style>